const PayPackageHome = () => import("../payPackage/views/PayPackageHome.vue");
const PayPackage = () => import("../payPackage/views/PayPackage.vue");
const PayPackageSettings = () =>
  import("../payPackage/views/PayPackageSettings.vue");
const PayPackageDetailsView = () =>
  import("../payPackage/views/PayPackageDetailsView.vue");
const PayBreakDownSettings = () =>
  import("../payPackage/views/PayBreakDownSettings.vue");
const PayBreakDownForm = () =>
  import("../payPackage/views/PayBreakDownForm.vue");
const PayBreakDownEdit = () =>
  import("../payPackage/views/PayBreakDownEdit.vue");
const ExtraAllowanceForm = () =>
  import("../payPackage/views/ExtraAllowanceForm.vue");
const ExtraAllowanceEdit = () =>
  import("../payPackage/views/ExtraAllowanceEdit.vue");
const ExtraAllowanceSettings = () =>
  import("../payPackage/views/ExtraAllowanceSettings.vue");
const AllowanceForm = () => import("../payPackage/views/AllowanceForm.vue");
const AllowanceEdit = () => import("../payPackage/views/AllowanceEdit.vue");
const AllowanceSettings = () =>
  import("../payPackage/views/AllowanceSettings.vue");
const CompanyRemittanceSettings = () =>
  import("../payPackage/views/CompanyRemittanceSettings.vue");
const CompanyRemittanceForm = () =>
  import("../payPackage/views/CompanyRemittanceForm.vue");
const CompanyRemittanceEditForm = () =>
  import("../payPackage/views/CompanyRemittanceEditForm.vue");
const StatutoryDeductionsForm = () =>
  import("../payPackage/views/StatutoryDeductionsForm.vue");
const StatutoryDeductionsSettings = () =>
  import("../payPackage/views/StatutoryDeductionsSettings.vue");
const StatutoryDeductionEdit = () =>
  import("../payPackage/views/StatutoryDeductionEdit.vue");
const StatutoryDeductionView = () =>
  import("../payPackage/components/StatutoryDeductionView");
const BatchingAndGroupingSettings = () =>
  import("../payPackage/views/BatchingAndGroupingSettings");
const BatchingAndGroupingForm = () =>
  import("../payPackage/views/BatchingAndGroupingForm");
const BatchingAndGroupingEditForm = () =>
  import("../payPackage/views/BatchingAndGroupingEditForm");
const BatchingAndGroupingDetailsView = () =>
  import("../payPackage/components/BatchingAndGroupingDetailsView");
const LatenessDeductionSettings = () =>
  import("../payPackage/views/LatenessDeductionSettings.vue");

export default [
  {
    path: "all",
    component: PayPackageHome,
  },
  {
    path: "create",
    component: PayPackage,
  },
  {
    path: "edit/:id",
    component: PayPackage,
  },
  {
    path: "view/:id",
    component: PayPackageDetailsView,
  },
  {
    path: "settings",
    component: PayPackageSettings,
  },
  {
    // name: "view-all-payBreakdown",
    path: "settings/pay-breakdown",
    component: PayBreakDownSettings,
  },
  {
    path: "settings/pay-breakdown/create",
    component: PayBreakDownForm,
  },
  {
    path: "settings/company-remittance",
    component: CompanyRemittanceSettings,
  },
  {
    path: "settings/company-remittance/create",
    component: CompanyRemittanceForm,
  },
  {
    name: "edit-company-remittance",
    path: "settings/company-remittance/edit/:id",
    component: CompanyRemittanceEditForm,
  },
  {
    path: "settings/batching-and-grouping",
    component: BatchingAndGroupingSettings,
  },
  {
    path: "settings/batch-and-grouping/create",
    component: BatchingAndGroupingForm,
  },
  {
    name: "edit-batching-and-grouping",
    path: "settings/batch-and-grouping/edit/:id",
    component: BatchingAndGroupingEditForm,
  },
  {
    name: "view-batching-and-grouping",
    path: "settings/batch-and-grouping/view/:id",
    component: BatchingAndGroupingDetailsView,
  },
  {
    name: "edit-payBreakDown",
    path: "settings/pay-breakdown/edit/:id",
    component: PayBreakDownEdit,
  },
  {
    path: "settings/allowance/create",
    component: AllowanceForm,
  },
  {
    name: "edit-allowance",
    path: "settings/allowance-edit/:id",
    component: AllowanceEdit,
  },
  {
    path: "settings/allowance",
    component: AllowanceSettings,
  },
  {
    path: "settings/extra-allowance/create",
    component: ExtraAllowanceForm,
  },
  {
    name: "edit-extra-allowance",
    path: "settings/extra-allowance-edit/:id",
    component: ExtraAllowanceEdit,
  },
  {
    path: "settings/extra-allowance",
    component: ExtraAllowanceSettings,
  },
  {
    path: "settings/statutory-deductions/create",
    component: StatutoryDeductionsForm,
  },
  {
    path: "settings/statutory-deductions",
    component: StatutoryDeductionsSettings,
  },
  {
    path: "settings/lateness-deduction",
    component: LatenessDeductionSettings,
  },
  {
    name: "statutory-deduction-edit",
    path: "settings/statutory-deduction-edit/:id",
    component: StatutoryDeductionEdit,
  },
  {
    name: "statutory-deduction-view",
    path: "settings/statutory-deduction-view/:id",
    component: StatutoryDeductionView,
  },

  // {
  //   path: "settings/upload-payment-history",
  //   component: UploadedPaymentHistoryForm
  // },
  // {
  //   path: "settings/upload-payment-history/create",
  //   component: UploadedPaymentHistorySettings
  // }
];
